import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await signup(name, email, password);
      toast.success("Welcome to shopnest");
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Sign up failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-white min-h-screen" data-testid="signup-page">
      <div className="max-w-md mx-auto px-6 pt-10 pb-16">
        <div className="text-center mb-8">
          <Link to="/" className="font-display text-3xl font-semibold">shopnest<span className="text-[#c8532e]">.</span></Link>
        </div>
        <div className="card p-6">
          <h1 className="font-display text-2xl font-semibold mb-4">Create account</h1>
          <form onSubmit={submit} className="space-y-4">
            <Field label="Your name" value={name} setValue={setName} testId="signup-name-input" />
            <Field label="Email" type="email" value={email} setValue={setEmail} testId="signup-email-input" />
            <Field label="Password" type="password" value={password} setValue={setPassword} testId="signup-password-input" hint="At least 6 characters" min={6} />
            <button type="submit" disabled={busy} className="btn-primary w-full text-sm" data-testid="signup-submit">
              {busy ? "Creating account…" : "Create your shopnest account"}
            </button>
          </form>
        </div>

        <div className="mt-6 text-sm">
          Already have an account?{" "}
          <Link to="/login" className="ec-link" data-testid="signup-to-login">Sign in →</Link>
        </div>
      </div>
    </div>
  );
}

function Field({ label, value, setValue, testId, type = "text", hint, min }) {
  return (
    <label className="block">
      <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[#6b6b6b]">{label}</span>
      <input
        type={type}
        required
        minLength={min}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="mt-1 w-full h-10 bg-white border border-[#e0d8c8] focus:border-[#c8532e] focus:ring-2 focus:ring-[#c8532e]/30 rounded-md outline-none px-3 text-sm"
        data-testid={testId}
      />
      {hint && <div className="mt-1 text-xs text-[#6b6b6b]">{hint}</div>}
    </label>
  );
}
